export const QNA_INVESTASI = [
  {
    title: "Kesempatan Modal Investasi 100RB",
    content: `<ol class="list-decimal px-4"> 
      <li class="mb-3">
        Program masih berlangsung dan berlaku untuk seluruh
        nasabah baru PT Sinarmas Sekuritas yang masuk melalui
        Program Referral sejak tanggal 22 Maret 2022 hingga 31 Mei 2022.
        (Untuk informasi lengkapnya ada di <a class="cursor-pointer text-rose-500" target="_blank" href="https://sinarmassekuritas.zendesk.com/hc/id-id/articles/4411547933209-Syarat-Dan-Ketentuan-Program-Referral">klik disini</a>)
      </li>
      <li class="mb-3">
        Bonus Modal Investasi sejumlah Rp100.000,- (seratus ribu rupiah) diberikan
        kepada Nasabah baru yang melakukan pembelian saham pertama kali via
        SimInvest Mobile dan nilai pembelian tersebut termasuk dalam 50 (lima puluh)
        orang dengan pembelian saham pertama kali tertinggi pada hari itu.
      </li>
      <li class="mb-3">
        Bonus Modal Investasi akan ditransfer ke Rekening Dana Nasabah (RDN)
        PT Bank Sinarmas Tbk (“Bank Sinarmas”) dalam 2 (dua) hari kerja setelah terkonfirmasi otomatis oleh sistem.
      </li>
      <li class="mb-3">
        Semua reward berupa Bonus Modal Investasi (saldo RDN) yang
        diberikan akan mengikuti ketentuan yang ditetapkan oleh Bank Sinarmas.
      </li>
      <li class="mb-3">
        Sinarmas Sekuritas berhak mengubah Syarat dan Ketentuan (S&K) dari waktu ke waktu,
        dan nasabah baru Sinarmas Sekuritas dianggap setuju. Selanjutnya nasabah diimbau secara
        berkala meninjau informasi (S&K) secara teratur untuk mengetahui perubahan terbaru pada (S&K) yang berlaku.
      </li>
    </ol>
  `,
  },
];

export const QNA_WITHDRAW = [
  {
    title:
      "Syarat & Ketentuan Withdrawal Rekening Dana Nasabah (RDN) Di Sinarmas Sekuritas",
    content: `
      <ul class="list-disc px-4"> 
        <li class="mb-3">
          Dana yang dapat ditarik/withdrawal adalah dana yang tersedia di
          Rekening Dana Nasabah (RDN) (good fund) setelah dikurangi dengan kewajiban/interest (jika ada)
          dan posisi Open Buy serta Net Buy Withdrawal yang dilakukan sebelum jam 14.00 WIB, akan diproses
          dalam 1 x 24 jam pada hari kerja bursa (di luar hari libur/akhir pekan). 
        </li>
        <li class="mb-3">
          Withdrawal yang dilakukan setelah jam 14.00 WIB, akan diproses dalam 2 x 24 jam pada hari kerja bursa (di luar hari libur/akhir pekan)
        </li>
        <li class="mb-3">
          Minimal penarikan dana sebesar Rp 100.000.
        </li>
        <li class="mb-3">
          Saldo minimum di RDN setelah penarikan sebesar Rp 100.000.
        </li>
        <li class="mb-3">
          Dana top-up tidak dapat ditarik pada hari yang sama, saat top-up dilakukan
        </li>
        <li class="mb-3">
          Dana hasil penjualan belum dapat ditarik pada hari yang sama, saat penjualan dilakukan.
        </li>
        <li class="mb-3">
          Hari kerja bursa adalah hari operasional kerja Bursa Efek Indonesia (BEI) pada Senin - Jumat, di luar hari libur nasional dan pada akhir pekan). Selengkapnya di : <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://www.idx.co.id/berita/jadwal-libur-bursa/">https://www.idx.co.id/berita/jadwal-libur-bursa/</a>
        </li>
      </ul>
  `,
  },
  {
    title: "Cara Withdrawal RDN Di Sinarmas Sekuritas",
    content: `
    <div>
      <div class="mb-3">Kamu bisa melakukan penarikan dana atau withdrawal Rekening Dana Nasabah (RDN) dengan tiga cara. Berikut tahapan withdrawal: </div>
      <ol class="list-decimal px-4 ml-1">
        <li class="mb-4">Melalui Aplikasi SimInvest:
          <div class="mt-1">
            <div class="mb-1">1.1 Login ke Aplikasi SimInvest</div>
            <div class="mb-1">1.2 Pilih menu Profile</div>
            <div class="mb-1">1.3 Pilih menu Cash Withdrawal</div>
            <div class="mb-1">1.4 Masukan Nominal Penarikan</div>
            <div class="mb-1">1.5 Klik Withdrawal</div>
          </div>
        </li>
        <li class="mb-4">Melalui SimInvest Desktop:
          <div class="mt-1">
            <div class="mb-1">2.1 Login ke SimInvest Desktop</div>
            <div class="mb-1">2.2 Masuk ke menu Account</div>
            <div class="mb-1">2.3 Pilih menu cash withdrawal</div>
            <div class="mb-1">2.4 Masukkan nominal penarikan di bagian withdrawal detail</div>
            <div class="mb-1">2.5 Klik submit withdrawal</div>
          </div>
        </li>
        <li class="mb-4">Mengisi form dan kirim formnya:
          <div class="mt-1">
            <div class="mb-1">
              3.1 Download “Formulir Permohonan Penarikan Dana” di website
              <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://www.sinarmassekuritas.co.id/formulir">https://www.sinarmassekuritas.co.id/formulir</a>
            </div>
            <div class="mb-1">3.2 Isi formulir dengan lengkap dan pastikan telah sesuai data yang ada</div>
            <div class="mb-1">3.3 Hubungi admin cabang atau representative sales yang bersangkutan untuk mendapatkan formulir penarikan</div>
            <div class="mb-1">3.4 Masukkan nominal penarikan di bagian withdrawal detail</div>
            <div class="mb-1">3.5 Kirim formulir penarikan dana, melalui fax ke nomor: (021) 31990045 atau email: <a class="break-all cursor-pointer text-rose-500" target="_blank" href="mailto:cs@sinarmassekuritas.co.id">cs@sinarmassekuritas.co.id</a></div>
          </div>
        </li>
        <li class="mb-4 hidden">Melalui Simas Equity Desktop:
          <div class="my-4">(Cara Withdrawal ini, hanya akan berlaku sampai 31 Desember 2021. Selanjutnya seluruh proses penarikan hanya dapat melalui: Simas Equity & SimInvest).</div>
          <div>
            <div class="mb-2">3.1 Formulir withdrawal dapat diperoleh melalui :
              <div class="pl-6">                
                  <div class="mb-1">3.1.1. Download “Formulir Permohonan Penarikan Dana” di website <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://www.sinarmassekuritas.co.id/formulir">https://www.sinarmassekuritas.co.id/formulir</a></div>
                  <div>3.1.2. Hubungi admin Cabang atau Representative Sales yang bersangkutan untuk mendapatkan formulir penarikan dan</div>
                  </div>
            </div>
            <div class="mb-1">3.2 Mengisi formulir dengan lengkap</div>
            <div>3.3 Kirim formulir penarikan dana, melalui fax ke nomor: (021) 31990045 atau email: <a class="break-all cursor-pointer text-rose-500" target="_blank" href="mailto:cs@sinarmassekuritas.co.id">cs@sinarmassekuritas.co.id</a></div>
          </div>
        </li>
      </ol>
    </div>
  `,
  },
  {
    title: "Cek Status Withdrawal",
    content: `
    <div class="mb-3">Status withdrawal berhasil adalah dana berhasil diterima nasabah dengan nominal dan batas waktu yang sesuai pada Syarat & Ketentuan (S&K) berlaku.  Namun jika terjadi kendala saat withdrawal, berikut solusinya:</div>

    <div class="mb-6 pt-4">
      <div class="mb-3">
        I. Status withdrawal gagal atau bermasalah 
        <br/>
        <div class="px-3">
          Dana belum kamu lebih dari batas waktu yang sesuai dengan S&K berlaku. Maka, kamu bisa melakukan hal berikut:
        </div>
      </div>
      <ol class="list-decimal px-6">
        <li class="mb-2">Cek lebih dulu status withdrawal di aplikasi SimInvest dan email kamu yang terdaftar</li>
        <li class="mb-2">Pastikan saldo yang hendak kamu tarik telah memenuhi kriteria yang telah ditentukan (Cek kembali S&K withdrawal Rekening Dana Nasabah Sinarmas Sekuritas)</li>
        <li class="mb-2">
          Jika masih terkendala, kamu bisa menghubungi Customer Support kami di :
          <ul class="px-6">
            <li class="mb-1">WhatsApp : <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://api.whatsapp.com/send/?phone=628875050700&text&app_absent=0">+628875050700</a></li>
            <li class="mb-1">Instagram: 
            <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://www.instagram.com/sim_invest/">@sim_invest</a> atau 
            <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://www.instagram.com/sim_invest/">@sinarmas_sekuritas</a></li>
            <li class="mb-1">Email : <a class="break-all cursor-pointer text-rose-500" target="_blank" href="mailto:cs@sinarmassekuritas.co.id">cs@sinarmassekuritas.co.id</a></li>
            <li class="mb-1">Hotline : +62 21 5050 7000 atau +62 21 392 5550</li>
          </ul>
        </li>
      </ol>
    </div>

    <div class="mb-6 pt-4">
      <div class="mb-3">
        II. Penarikan dana gagal atau belum dapat diproses  
        <br/>
        <div class="px-4">Kamu bisa melakukan hal berikut: </div>
      </div>
      <ol class="list-decimal px-6">
        <li class="mb-2">Pastikan saldo yang hendak kamu tarik telah memenuhi kriteria yang telah ditentukan (Cek kembali S&K withdrawal Rekening Dana Nasabah Sinarmas Sekuritas)</li>
        <li class="mb-2">Pastikan nomor rekening, nama pemilik rekening & bank tujuan sudah sesuai</li>
        <li class="mb-2">Tidak ada transaksi yang outstanding (Kamu sudah menyelesaikan seluruh kewajiban pembayaran pembelian saham)</li>
        <li class="mb-2">
          Jika masih terkendala, kamu bisa menghubungi Customer Support kami di :
          <ul class="px-6">
            <li class="mb-1">WhatsApp : <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://api.whatsapp.com/send/?phone=628875050700&text&app_absent=0">+628875050700</a></li>
            <li class="mb-1">Instagram: 
            <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://www.instagram.com/sim_invest/">@sim_invest</a> atau 
            <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://www.instagram.com/sim_invest/">@sinarmas_sekuritas</a></li>
            <li class="mb-1">Email : <a class="break-all cursor-pointer text-rose-500" target="_blank" href="mailto:cs@sinarmassekuritas.co.id">cs@sinarmassekuritas.co.id</a></li>
            <li class="mb-1">Hotline : +62 21 5050 7000 atau +62 21 392 5550</li>
          </ul>
        </li>
      </ol>
    </div>

    <div class="mb-6 pt-4">
      <div class="mb-3">
        III. Nominal penarikan dana yang diterima tidak sesuai dengan yang diajukan  
        <br/>
        <div class="px-5">
          Jika kamu mengalami situasi tersebut, berikut hal yang bisa kamu lakukan:
        </div>
      </div>
      <ol class="list-decimal px-6">
        <li class="mb-2">Pastikan saldo yang hendak kamu tarik telah memenuhi kriteria yang telah ditentukan (Cek kembali S&K withdrawal Rekening Dana Nasabah Sinarmas Sekuritas)</li>
        <li class="mb-2">Pastikan apakah masih ada transaksi yang outstanding / kewajiban yang belum dibayarkan.</li>
        <li class="mb-2">Tidak ada transaksi yang outstanding (Kamu sudah menyelesaikan seluruh kewajiban pembayaran pembelian saham)</li>
        <li class="mb-2">
          Jika masih terkendala, kamu bisa menghubungi Customer Support kami di :
          <ul class="px-6">
            <li class="mb-1">WhatsApp : <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://api.whatsapp.com/send/?phone=628875050700&text&app_absent=0">+628875050700</a></li>
            <li class="mb-1">Instagram: 
            <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://www.instagram.com/sim_invest/">@sim_invest</a> atau 
            <a class="break-all cursor-pointer text-rose-500" target="_blank" href="https://www.instagram.com/sim_invest/">@sinarmas_sekuritas</a></li>
            <li class="mb-1">Email : <a class="break-all cursor-pointer text-rose-500" target="_blank" href="mailto:cs@sinarmassekuritas.co.id">cs@sinarmassekuritas.co.id</a></li>
            <li class="mb-1">Hotline : +62 21 5050 7000 atau +62 21 392 5550</li>
          </ul>
        </li>
      </ol>
    </div>
    `,
  },
  {
    title: "Dana Saya Belum Masuk, Bagaimana Mengeceknya?",
    content: `
    <ul class="list-disc px-4">
      <li class="mb-2">
        <div class="mb-2">Cara Cek Dana Kamu, Jika Belum Masuk </div>
        <div>Kamu bisa cek status withdrawal dari laman History di SimInvest, caranya sebagai berikut: </div>
        <ol class="list-decimal px-5">
          <li>Login ke SimInvest</li>
          <li>Masuk ke Home Page</li>
          <li>Klik saldo Rekening Dana Nasabah (RDN) di bawah Profil Nama</li>
          <li>Pilih menu Riwayat untuk mengecek status withdrawal</li>
        </ol>
      </li>
      <li>
        Jika dana masih belum diterima lebih dari 2 x 24 jam pada hari kerja bursa, setelah pengajuan withdrawal dilakukan silahkan hubungi Customer Support SimInvest & Sinarmas Sekuritas di:
        <div class="mt-1">
          <ul class="px-6">
            <li class="mb-1">
              WhatsApp :
              <a
                class="break-all cursor-pointer text-rose-500"
                target="_blank"
                href="https://api.whatsapp.com/send/?phone=628875050700&text&app_absent=0"
                >+628875050700</a
              >
            </li>
            <li class="mb-1">
              Instagram:
              <a
                class="break-all cursor-pointer text-rose-500"
                target="_blank"
                href="https://www.instagram.com/sim_invest/"
                >@sim_invest</a
              >
              atau
              <a
                class="break-all cursor-pointer text-rose-500"
                target="_blank"
                href="https://www.instagram.com/sim_invest/"
                >@sinarmas_sekuritas</a
              >
            </li>
            <li class="mb-1">
              Email :
              <a
                class="break-all cursor-pointer text-rose-500"
                target="_blank"
                href="mailto:cs@sinarmassekuritas.co.id"
                >cs@sinarmassekuritas.co.id</a
              >
            </li>
            <li class="mb-1">Hotline : +62 21 5050 7000 atau +62 21 392 5550</li>
          </ul>
        </div>
      </li>
    </ul>   
    `,
  },
  {
    title: "Istilah Dalam Withdrawal",
    content: `
    <ul class="px-4">
      <li class="mb-2">a. Kriteria dana disebut Good Fund:
        <ul class="px-5">
          <li>
            i. Dana yang sedang tidak digunakan atau terlibat dalam transaksi apapun
          </li>
          <li>
            ii. Jika dana berasal dari hasil penjualan saham reguler, maka dana harus sudah tersedia minimal 2 x 24 jam (hari kerja bursa) setelah penjualan dilakukan
          </li>
        </ul>
      </li>
      <li class="mb-2">b. Open Buy
        <div class="px-5">
          i. Nominal transaksi beli yang statusnya belum match pada trading sistem
        </div>
      </li>
      <li class="mb-2">
        c. Net Buy
        <div class="px-5">
          i. Nominal Transaksi beli yang sudah match lebih besar daripada transaksi penjualan yang sudah match
        </div>
      </li>
      <li class="mb-2">
        d. Interest
        <div class="px-5">
          i. Denda yang terjadi karena dana tidak mencukupi saat nasabah melakukan pembelian saham
        </div>
      </li>
    </ul>
    `,
  },
];

export const QNA_STARPOIN = [
  {
    title: "Apa Itu StarPoin?",
    content: `StarPoin adalah loyalty poin program milik Sinarmas Group. StarPoin dapat diakses dan digunakan melalui aplikasi StarPoin yang tersedia di App Store & Play Store`,
  },
  {
    title: "Apa Kegunaan Dari Starpoin?",
    content: `StarPoin dapat digunakan sebagai alat tukar untuk mendapatkan berbagai macam promo, rewards, dan juga RDN untuk berinvestasi di aplikasi SimInvest dan aplikasi StarPoin.`,
  },
  {
    title:
      "Apa Saja Promo, Hadiah dan Rewards Yang Bisa Ditukarkan Dengan StarPoin?",
    content: `<div>StarPoin dapat digunakan sebagai alat tukar untuk mendapatkan berbagai macam promo, rewards, dan juga RDN untuk berinvestasi di aplikasi SimInvest dan aplikasi StarPoin. Cek detail promo dan rewards di aplikasi StarPoin</div>
    <a class="inline-block my-6 bg-red-600 text-white hover:text-slate-500 hover:bg-white hover:border hover:border-slate-500 px-4 py-3 transition-colors ease-in-out" href="https://starpoin.id/all-merchant/">KETAHUI LEBIH LANJUT</a>`,
  },
  {
    title: "Cara Dapat StarPoin",
    content: `
    <ol class="list-decimal px-4">
      <li class="mb-4">
        <div class="mb-2">Nasabah existing Sinarmas Sekuritas</div>
        <div>
        Jika kamu sudah menjadi nasabah Sinarmas Sekuritas sebelum tanggal 28 Juli 2021, kamu hanya perlu register dan Login di aplikasi SimInvest untuk mendapatkan rewards aktivasi StarPoin @20.000. Poin yang kamu dapatkan akan di proses di minggu berikutnya. 
        </div>
      </li>
      <li>
        <div class="mb-2">Bertransaksi di SimInvest</div>
        <div>
        Jika kamu bertransaksi dengan membeli atau menjual saham di aplikasi SimInvest, maka kamu akan mendapatkan StarPoin 0,01% dari setiap nilai transaksi. Contoh: Kamu bertransaksi saham dengan nilai Rp 100.000, maka akan mendapatkan 10 StarPoin. 
        </div>
      </li>
    </ol>
    `,
  },
  {
    title: "Syarat dan Ketentuan (S&K) Dapat StarPoin di SimInvest",
    content: `
    <ol class="list-decimal px-4">
      <li class="mb-2">
      Bertransaksi pembelian atau penjualan saham dengan menggunakan aplikasi SimInvest
      </li>
      <li class="mb-2">
      Nasabah individu bukan dari berasal dari organisasi atau institusi
      </li>
    </ol>
    `,
  },
  {
    title: "Cara Menukar StarPoin Jadi Rewards",
    content: `
    <ol class="list-decimal px-4">
      <li class="mb-2">Kalau kamu sudah download StarPoin dan sukses registrasi, kamu hanya perlu buka aplikasi StarPoin</li>
      <li class="mb-2">Selanjutnya login StarPoin</li>
      <li class="mb-2">Buka menu produk</li>
      <li class="mb-2">Pilih redeem e-voucher</li>
      <li class="mb-2">Lalu pilih e-voucher yang diinginkan pada katalog</li>
      <li class="mb-2">Selanjutnya masukkan jumlah e-voucher yang diinginkan</li>
      <li class="mb-2">Tekan tombol Redeem Sekarang./li>
      <li>Jika penukaran StarPoin berhasil, kamu bisa mengecek e-voucher yang digunakan di menu my e-voucher</li>
    </ol>
    `,
  },
  {
    title: "Sampai Kapan Periode Berlangsung? ",
    content: `
    <ul class="list-disc px-4">
      <li class="mb-2">Rewards StarPoin dimulai dari tanggal 28 Juli 2021 sampai 31 Desember 2022</li>
      <li>S&K berlaku untuk program StarPoin ini dapat berubah sewaktu-waktu tanpa adanya pemberitahuan sebelumnya</li>
    </ul>
    `,
  },
];

export const QNA_IPO = [
  {
    title: "PENDAFTAR SISTEM E-IPO",
    content: `
    <a
    class="break-all cursor-pointer text-rose-500"
    target="_blank"
    href="https://www.sinarmassekuritas.co.id/download/pendaftaran-sistem-e-ipo"
    >
      Download tata cara pendaftaran
    </a>
    `,
  },
];

export const QNA_EQUITY = [
  {
    title: "STRATEGI PERGANTIAN SIMAS EQUITY KE NEW SIMAS EQUITY",
    content: `
    <div>
      Target pelaksanaan : Juni – Agustus 2020
      <div class="mt-6 mb-2">
        <div class="font-bold mb-2">Batch 5</div>
        <table class="table-auto">
          <thead>
            <tr class="border-b border-t border-slate-200">
              <th class="text-left w-1/6 py-4">Tanggal</th>
              <th class="text-left w-auto px-4">Target</th>
              <th class="text-left w-1/2">Nama Lokasi</th>
              <th class="text-left">Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="pt-4 w-1/6">04 Juni 2020</td>
              <td class="font-bold w-auto px-4">Nasabah dan Sales</td>
              <td class="pt-4 w-1/2">
                Sales Regional Jawa Tengah Meliputi : Kota Solo, Magelang, Semarang,
                Yogyakarta
              </td>
              <td class="w-auto pt-4">
                Seluruh nasabah Sinarmas Sekuritas dan Sales
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-6 mb-2">
        <div class="font-bold mb-2">Batch 6</div>
        <table class="table-auto">
          <thead>
            <tr class="border-b border-t border-slate-200">
              <th class="text-left w-auto py-4">Tanggal</th>
              <th class="text-left w-auto px-4">Target</th>
              <th class="text-left w-1/4">Nama Lokasi</th>
              <th class="text-left w-auto">Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="pt-4 w-1/6">11 Juni 2020</td>
              <td class="pt-4 px-4 w-1/4 font-bold">Nasabah dan Sales</td>
              <td class="pt-4 w-1/4 border-b border-slate-200">Cabang Tegal</td>
              <td class="pt-4 w-auto px-4" rowspan="3">
                Seluruh nasabah Sinarmas Sekuritas dan Sales
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="pt-4 pb-2 border-b border-t border-slate-200">Cabang Jambi</td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="pt-4 pb-2 border-b border-t border-slate-200">Cabang Manado</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-6 mb-2">
        <div class="font-bold mb-2">Batch 7</div>
        <table class="table-auto">
          <thead>
            <tr class="border-b border-t border-slate-200">
              <th class="text-left py-4">Tanggal</th>
              <th class="text-left px-4">Target</th>
              <th class="text-left px-4">Nama Lokasi</th>
              <th class="text-left">Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>25 Juni 2020</td>
              <td class="font-bold px-4">Nasabah dan Sales</td>
              <td class="px-4">Kantor Pusat</td>
              <td class="pt-4 w-1/3">
                Seluruh nasabah yang trading via online ataupun dengan sales kantor
                pusat
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-6 mb-12">
        <div class="font-bold mb-2">Batch 8</div>
        <table class="table-auto">
          <thead>
            <tr class="border-b border-t border-slate-200">
              <th class="text-left py-4">Tanggal</th>
              <th class="text-left px-4">Target</th>
              <th class="text-left">Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="pt-4">09 ‐ 31 Juli 2020</td>
              <td class="font-bold pt-4 px-4">Seluruh nasabah Stockbit</td>
              <td class="pt-4">Seluruh nasabah yang bertransaksi via aplikasi StockBit</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-6 mb-2">
        <div class="font-bold mb-2">Batch 9</div>
        <table class="table-auto">
          <thead>
            <tr class="border-b border-t border-slate-200">
              <th class="text-left py-4">Tanggal</th>
              <th class="text-left px-4">Target</th>
              <th class="text-left">Keterangan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="pt-4 w-1/5">01-14 Agustus 2020</td>
              <td class="font-bold pt-4 px-4">
                Masa Retensi sebelum Aplikasi SimasNet V2 dinonaktifkan pada tanggal
                17 Agustus 2020
              </td>
              <td class="pt-4">Seluruh system SimasNet V2 akan dinonaktifkan</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    `,
  },
];

export const QNA_PASAR = [
  {
    title: "Mengenal Pasar Modal",
    content: `
    <p class="mb-4">
      Undang-Undang Pasar Modal No. 8 tahun 1995 tentang Pasar Modal mendefinisikan
      pasar modal sebagai “kegiatan yang bersangkutan dengan Penawaran Umum dan
      perdagangan Efek, Perusahaan Publik yang berkaitan dengan Efek yang
      diterbitkannya, serta lembaga dan profesi yang berkaitan dengan Efek”.
    </p>
    <p class="mb-4">
      Pasar Modal mengacu pada kegiatan yang mengumpulkan dana dari beberapa pihak
      dan membuatnya tersedia untuk pihak lain yang membutuhkan dana. Fungsi inti
      dari pasar semacam itu adalah untuk meningkatkan efisiensi transaksi sehingga
      setiap entitas individu tidak perlu melakukan pencarian dan analisis, membuat
      perjanjian hukum, dan menyelesaikan transfer dana.
    </p>
    <p class="mb-4">
      Instrumen keuangan yang diperdagangkan di pasar modal merupakan instrumen
      jangka panjang (jangka waktu lebih dari 1 tahun) seperti saham, obligasi,
      waran, right, reksadana, dan berbagai instrumen derivatif seperti option,
      futures, dan lain-lain.
    </p>
    <p class="mb-4">
      Pasar Modal memiliki peran penting bagi perekonomian suatu negara karena pasar
      modal menjalankan dua fungsi, yaitu pertama sebagai sarana bagi pendanaan
      usaha atau sebagai sarana bagi perusahaan untuk mendapatkan dana dari
      masyarakat pemodal (investor). Dana yang diperoleh dari pasar modal dapat
      digunakan untuk pengembangan usaha, ekspansi, penambahan modal kerja dan
      lain-lain, kedua pasar modal menjadi sarana bagi masyarakat untuk berinvestasi
      pada instrument keuangan seperti saham, obligasi, reksa dana, dan lain-lain.
      Dengan demikian, masyarakat dapat menempatkan dana yang dimilikinya sesuai
      dengan karakteristik keuntungan dan risiko masing-masing instrument.
    </p>
    `,
  },
  {
    title: "Manfaat Pasar Modal Bagi Emiten",
    content: `
    <ol class="list-decimal px-4">
    <li class="mb-2">Jumlah dana yang dapat dihimpun berjumlah besar</li>
    <li class="mb-2">Dana tersebut dapat diterima sekaligus pada saat pasar perdana selesai</li>
    <li class="mb-2">Tidak ada convenant sehingga manajemen dapat lebih bebas dalam pengelolaan dana/perusahaan</li>
    <li class="mb-2">Solvabilitas perusahaan tinggi sehingga memperbaiki citra perusahaan</li>
    <li class="mb-2">Ketergantungan emiten terhadap bank menjadi lebih kecil </li>
    <li class="mb-2">Nilai investasi berkembang mengikuti pertumbuhan ekonomi. Peningkatan tersebut tercermin pada meningkatnya harga saham yang mencapai kapital gain</li>
    <li class="mb-2">Memperoleh dividen bagi mereka yang memiliki/memegang saham dan bunga yang mengambang bagi pemenang obligasi</li>
    <li>Dapat sekaligus melakukan investasi dalam beberapa instrumen yang mengurangi risiko</li>
    </ol>
    `,
  },
  {
    title: "Memahami Nilai Aktiva Bersih (NAB)",
    content: `NAB merupakan salah satu tolok ukur dalam memantau hasil dari suatu Reksadana. NAB per saham/unit penyertaan adalah harga wajar dari portofolio suatu Reksadana setelah dikurangi biaya operasional. Kemudian dibagi jumlah saham/unit penyertaan yang telah beredar (dimiliki investor) pada saat tersebut.`,
  },
  {
    title: "Mengenal dan Memahami Saham ",
    content: `
      <div>
      <p class="mb-2">Saham adalah salah satu instrumen pasar keuangan yang populer. Saham dapat didefinisikan tanda penyertaan atau kepemilikan seseorang atau badan dalam suatu perusahaan atau perseroan terbatas. </p>

      <p class="mb-2">Wujud kepmilikan saham adalah selembar kertas yang menerangkan bahwa pemilik kertas tersebut adalah pemilik perusahaan yang menerbitkan surat berharga tersebut. Porsi kepemilikan saham ditentukan seberapa besar penyertaan yang ditanamkan di perusahaan tersebut.</p>

      <p class="mb-2">Menerbitkan saham merupakan salah satu pilihan perusahaan ketika memutuskan untuk pendanaan perusahaan. Pada sisi yang lain, saham merupakan instrument investasi yang banyak dipilih para investor karena saham mampu memberikan tingkat keuntungan yang menarik.</p>
    </div>
  `,
  },
  {
    title: "Keuntungan Memiliki Saham",
    content: `
    <div>
      Berinvestasi saham dapat memberikan passive income. Nasabah bisa mendapatkan keuntungan sebagai berikut: 
      <div class="mt-6 mb-4">1. Dividen</div>
      <p class="mb-4 px-4">
        Adalah pembagian keuntungan yang diberikan perusahaan kepada investor. Keuntungan yang dihasilkan perusahaan disisihkan kepada investor dan diberikan setelah mendapat persetujuan dari pemegang saham dalam RUPS. 
      </p>
      <div class="mb-2">
        Syarat mendapatkan dividen: 
      </div>
      <ul class="list-disc mb-2 px-4">
        <li class="mb-2">
        Memiliki saham dalam periode tertentu dan diakui sebagai pemegang saham yang berhak mendapatkan dividen
        </li>
      </ul>

      <div class="mb-2">
        Dua bentuk dividen yang diterima investor: 
      </div>
      <ul class="list-disc mb-4 px-4">
        <li class="mb-2">
         Dividen tunai  : Pemegang saham mendapat dividen berupa uang tunai dalam jumlah rupiah tertentu untuk setiap saham yang dimiliki. 
        </li>
        <li class="mb-4">
        Dividen saham:  Pemegang saham mendapat dividen sejumlah saham sehingga jumlah saham yang dimiliki seorang pemodal akan bertambah dari pembagian dividen saham tersebut.
        </li>
      </ul>
      <p class="mb-6 px-4 hidden">
        Dividen yang dibagikan perusahaan dapat berupa dividen tunai - artinya
        kepada setiap pemegang saham diberikan dividen berupa uang tunai dalam
        jumlah rupiah tertentu untuk setiap saham - atau dapat pula berupa dividen
        saham yang berarti kepada setiap pemegang saham diberikan dividen sejumlah
        saham sehingga jumlah saham yang dimiliki seorang pemodal akan bertambah
        dengan adanya pembagian dividen saham tersebut.
      </p>

      <div class="mb-4 pt-4">2. Capital Gain</div>
      <p class="mb-4 px-4">
        Adalah selisih antara harga beli dan harga jual. Capital gain terbentuk karena aktivitas perdagangan saham di pasar sekunder. <br/>
        Sebagai contoh: Investor membeli saham ABC dengan harga per saham Rp 1.000 kemudian menjualnya dengan harga Rp 1.500 per saham yang berarti pemodal tersebut mendapatkan capital gain sebesar Rp 500 untuk setiap saham yang dijualnya.
      </p>
    </div>
    `,
  },
  {
    title: "Risiko Memiliki Saham",
    content: `
    <div>
      Risiko yang terdapat dari membeli atau memiliki saham :

      <div class="mt-4 mb-2">1. Capital Loss</div>
      <div class="px-4">
        <p class="mb-4">
          Merupakan kebalikan dari Capital Gain, yaitu suatu kondisi dimana investor menjual saham lebih rendah dari harga beli. Misalnya saham PT. ABCD yang di beli dengan harga Rp 2.500,- per saham, kemudian harga saham tersebut terus mengalami penurunan hingga mencapai Rp 2.100,- per saham.
        </p>

        <p>
          Karena takut harga saham tersebut akan terus turun, investor menjual pada harga Rp 2.100,- tersebut sehingga mengalami kerugian sebesar Rp 400,- per saham.
        </p>
      </div>

      <div class="mt-6 mb-2">2. Risiko Likuidasi</div>
      <p class="px-4">
        Perusahaan yang sahamnya dimiliki, dinyatakan bangkrut oleh Pengadilan, atau perusahaan tersebut dibubarkan. Dalam hal ini hak klaim dari pemegang saham mendapat prioritas terakhir setelah seluruh kewajiban perusahaan dapat dilunasi (dari hasil penjualan kekayaan perusahaan). Jika masih terdapat sisa dari hasil penjualan kekayaan perusahaan tersebut, maka sisa tersebut dibagi secara proporsional kepada seluruh pemegang saham. Namun jika tidak terdapat sisa kekayaan perusahaan, maka pemegang saham tidak akan memperoleh hasil dari likuidasi tersebut. Kondisi ini merupakan risiko yang terberat dari pemegang saham. Untuk itu seorang pemegang saham dituntut untuk secara terus menerus mengikuti perkembangan perusahaan.
      </p>
    </div>
    `,
  },
  {
    title: "Mengenal Istilah Dalam Pasar Modal",

    content: `
    <div class="mb-6">
      <div class="font-bold mb-2">Pasar Modal (Capital Market)</div>
      Adalah kegiatan yang mempertemukan pihak yang membutuhkan dana jangka panjang dan pihak yang membutuhkan sarana investasi terpercaya dan prospektif.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Bursa Efek (Stock Exchange)</div>
      Adalah kegiatan yang mempertemukan pihak yang membutuhkan dana jangka panjang dan pihak yang membutuhkan sarana investasi terpercaya dan prospektif.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Efek (Sekurities)</div>
      Yaitu merupakan surat berharga seperti surat pengakuan hutang, surat berharga komersial, saham, obligasi, tanda bukti hutang, unit penyertaan kontrak investasi kolektif, kontrak berjangka atas efek dan setiap derivatif dari efek.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Capital Gain vs Capital Loss</div>
      Capital Gain yaitu selisih harga pembelian saham dengan harga penjualan, apabila harga penjualan di atas harga pembelian. Capital Loss yaitu kebalikan dari capital gain, apabila harga penjualan saham lebih rendah dari harga pembelian.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Emiten</div>
        Yaitu perusahaan yang menawarkan efeknya kepada masyarakat melalui penawaran umum.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">HMETD (Hak Memesan Efek Terlebih Dahulu)</div>
      Adalah hak yang melekat pada saham yang memungkinkan para pemegang saham yang ada untuk membeli efek baru, termasuk saham.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Waran</div>
      Adalah efek yang diterbitkan oleh suatu perusahaan yang memberi hak kepada pemegang efek untuk memesan saham dari perusahaan tersebut pada harga tertentu untuk jangka waktu 6 (enam) bulan atau lebih sejak diterbitkannya waran tersebut.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Delisting</div>
      Adalah emiten yang efeknya telah dicatatkan di Bursa dan sekarang dikeluarkan dari pencatatan akibat dari gagalnya pemenuhan persyaratan Bursa.
      <div class="mt-4 mb-2">Delisting ada 2 jenis:</div>
      <div class="mb-2">
        1. Voluntary Delisting : Delisting yang dilakukan atas permintaan Emiten yang bersangkutan.
      </div>
      <div class="mb-2">
        2. Forced Delisting : Delisting yang dilakukan secara paksa oleh Bursa.
      </div>
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Harga Teoritis</div>
      Adalah sejumlah nilai yang dihitung berdasarkan ratio pembagian dividen saham, saham bonus, penerbitan HMETD, waran, Stock Split, Reverse Stock, penggabungan usaha, peleburan usaha perusahaan tercatat, dan Corporate Action lainnya yang ditetapkan oleh perusahaan tercatat.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Kontrak Investasi Kolektif</div>
      Adalah kontrak antara Manajer Investasi dan Bank Kustodian yang mengikat pemegang Unit Penyertaan dimana Manajer Investasi diberi wewenang untuk pengelola portofolio investasi kolektif dan Bank Kustodian diberi wewenang untuk melaksanakan Penitipan Kolektif.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Dividen</div>
      Merupakan pembagian keuntungan perusahaan kepada pemegang saham secara pro-rata dan dibayarkan dalam bentuk uang (dividen cash) dan atau saham (dividen stock), yang besarnya akan ditetapkan berdasarkan Rapat Umum Pemegang Saham (RUPS).
      <div class="my-4">
        Cum Dividen : Tanggal perdagangan terakhir yang masih mendapatkan kesempatan dividen.
      </div>
      <div class="my-4">
        Ex Dividen : Tanggal perdagangan yang tidak mendapatkan kesempatan memperoleh dividen.
      </div>
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Divestasi</div>
      Adalah pengurangan jumlah kepemilikan saham (pendiri/founder) atas suatu perusahaan sebagai akibat dari penjualan sebagian saham perusahaan kepada pihak lain atau kepada masyarakat.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Earning Per Share (EPS)</div>
      Adalah mengukur besarnya laba bersih yang diperoleh perusahaan atas setiap lembar yang dimiliki.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Initial Public Offering (IPO)</div>
      Yang dikenal dengan istilah Go-Public adalah kegiatan penawaran saham yang dilakukan oleh Emiten (Perusahaan yang akan Go-Public) untuk menjual saham atau efek kepada masyarakat berdasarkan tata cara yang diatur oleh UU Pasar Modal dan Peraturan Pelaksanaannya.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Stock Split vs Reverse Stock</div>
      <div class="my-3">Stock Split : pemecahan nilai nominal saham.</div>
      <div class="my-3">Reverse Stock : penggabungan nilai nominal saham.</div>
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Tanggal DPS (Daftar Pemegang Saham)</div>
      Adalah tanggal dimana investor masih tercatat/terdaftar sebagai pemegang
      saham.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Price Earning Ratio (PER)</div>
      Memperlihatkan berapa kali besranya penilaian publik/investor terhadap potensi
      keuntungan yang akan didapat perusahaan per-saham yang tercermin dalam harga
      pasar di bursa. Secara umum, semakin beasr PER membuat investor semakin
      percaya. Akan tetapi bisa berarti harga saham senakin mahal. Biasanya
      digunakan untuk perusahaan sector riil.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Strategic Listing</div>
      Perusahaan menjual sahamnya di Bursa, tetapi hamper sebagian besar/seluruhnya
      dibeli kembali sehingga saham yang beredar di publik untuk dapat
      diperdagangkan menjadi sangat terbatas.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Tindakan Korporasi (Corporate Action)</div>
      Adalah setiap tindakan Emiten yang memberikan hak kepada seluruh pemilik
      manfaat atas efek dari jenis dan kelas yang sama seperti hak untuk menghadiri
      Rapat Umum Pemegang Efek, hak untuk memperoleh dividen tunai, dividen efek,
      bonus efek, bonus tunai, hak memesan efek terlebih dahulu, waran, atau hak-hak
      lainnya.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Take Profit vs Cut Loss</div>
      <div class="mb-4">
        Take Profit : Tindakan melakukan penjualan saham yang dimiliki/telah dibeli
        setelah mencapai level harga/target yang direncanakan/diinginkan.
      </div>
    
      <div class="mb-4">
        Cut Loss : Tindakan melakukan penjualan saham yang dimiliki/telah dibeli
        untuk menghindari kerugian yang lebih besar yang disebabkan oleh pergerakan
        harga berlawanan dengan yang diperkirakan.
      </div>
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Penawaran Tender</div>
      Penawaran melalui Media Massa untuk memperoleh Efek bersifat Ekuitas dengan
      cara pembelian atau pertukaran dengan Efek lainnya.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Perusahaan Publik</div>
      Perseroan yang sahammnya telah dimiliki sekurang-kurangnya oleh 300 (tiga
      ratus) pemegang saham dan memiliki modal disektor sekurang-kurangnya Rp.
      3.000.000,00 (tiga miliar rupiah) atau suatu jumlah pemegang saham dan modal
      disetor yang ditetapkan dengan Peraturan Pemerintah.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Nilai Nominal (Nominal/Par Value)</div>
      Merupakan nilai yang tertera pada lembaran surat saham yang besarnya
      ditentukan dalam Anggaran Dasar Perusahaan.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Nilai Buku Per Saham (PBV)</div>
      Memperlihatkan berapa kali besarnya penilaian publik terhadap harga buku/nilai
      perusahaan per saham yang tercermin dalam harga pasar di Bursa. Semakin besar
      nilainya artinya semakin tinggi apresiasi investor terhadap nilai perusahaan
      tersebut. Biasanya digunakan untuk menilai perusahaan-perusahaan jasa
      keuangan.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Kapitalisasi Pasar (Market Capitalization)</div>
      Merupakan perkalian harga saham di bursa (market price) dengan jumlah lembar
      saham yang telah disetor.
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Margin Trading</div>
      Transaksi bursa yang dilakukan oleh Anggota Bursa Efek untuk kepentingan
      nasabahnya yang penyelesaian transaksinya dibiayai oleh Anggota Bursa Efek
      tersebut.(Peraturan BEJ No. 11-9. th.1997).
    </div>
    
    <div class="mb-6">
      <div class="font-bold mb-2">Margin Call</div>
      Batasan dimana nasabah harus menambah jumlah uang setoran sebagai akibat
      turunnya harga saham yang dimilikinya (ketentuan yang berlaku sebesar 65%).
    </div>
    
    <div>
      <div class="font-bold mb-2">Bank kustodian</div>
      Bank kustodian atau disingkat kustodian adalah suatu lembaga yang bertanggung
      jawab untuk mengamankan aset keuangan dari suatu perusahaan ataupun
      perorangan.
    </div>  
    `,
  },
];

export const QNA_UMUM = [
  {
    title:
      "Berapa % Denda Keterlambatan Apablia Nasabah Tidak Membayar Pada Jatuh Tempo?",
    content: `45% p.a atau 0.125% per hari.`,
  },
  {
    title:
      "Apa Yang Terjadi Bila Nasabah Tidak Membayar Kewajibannya Sesuai Dengan Jatuh Tempo?",
    content: `T+2 akan suspend buy dan dikenakan denda keterlambatan, T+4 akan di forcesell`,
  },
  {
    title: "Kapan Jadwal Trading Bursa?",
    content: `
    <div class="mt-4">
  <table class="table-auto w-full">
    <thead>
      <tr class="border-b-2 border-t border-slate-200">
        <th class="text-left py-4 px-4">Sesi Perdagangan</th>
        <th class="text-left">Pasar</th>
        <th class="text-left">Waktu Perdagangan</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="w-2/6 pt-4 px-4">Sesi Pra-Pembukaan</td>
        <td class="w-2/6 pt-4">Reguler</td>
        <td class="pt-4">08:45:00 - 08:55:00</td>
      </tr>
    </tbody>
  </table>

  <div class="py-6"></div>

  <table class="table-auto border-b border-t border-slate-200 w-full">
    <tbody class="py-10">
      <tr>
        <td class="w-2/6 px-4 pt-2">Sesi 1</td>
        <td class="w-2/6 pt-2">Reguler, Tunai, Negosiasi</td>
        <td class="w-2/6 pt-2 pb-4">Senin - Kamis : 09:00:00 - 12:00:00</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td class="w-2/6 pb-2">Jumat : 09:00:00 - 11:30:00</td>
      </tr>
    </tbody>
  </table>

  <div class="py-6"></div>

  <table class="table-auto border-b border-t border-slate-200 w-full">
    <tbody class="py-10">
      <tr>
        <td class="w-2/6 px-4 pt-2">Sesi 2</td>
        <td class="w-2/6 pt-2">Reguler</td>
        <td class="w-2/6 pt-2 pb-4">Senin - Kamis : 13:30:00 - 15:49:59</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td class="w-2/6 pb-2">Jumat : 14:00:00 - 15:49:59</td>
      </tr>
    </tbody>
  </table>

  <div class="py-6"></div>

  <table class="table-auto border-b border-t border-slate-200 w-full">
    <tbody class="py-10">
      <tr>
        <td class="w-2/6 px-4 pt-2">Sesi Pra-Penutupan</td>
        <td class="w-2/6 pt-2">Reguler</td>
        <td class="w-2/6 pt-2 pb-4">15:50:00 - 16:00:00</td>
      </tr>
    </tbody>
  </table>

  <div class="py-6"></div>

  <table class="table-auto border-b border-t border-slate-200 w-full">
    <tbody class="py-10">
      <tr>
        <td class="w-2/6 px-4 pt-2">Sesi Pasca-Penutupan</td>
        <td class="w-2/6 pt-2">Reguler</td>
        <td class="w-2/6 pt-2 pb-4">16:05:00 - 16:15:00</td>
      </tr>
    </tbody>
  </table>

  <div class="py-6"></div>

  <table class="table-auto border-b border-t border-slate-200 w-full">
    <tbody class="py-10">
      <tr>
        <td class="w-2/6 px-4 pt-2">Sesi 2</td>
        <td class="w-2/6 pt-2">Negosiasi</td>
        <td class="w-2/6 pt-2 pb-4">Monday - Thursday : 13:30:00 - 16:15:00</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td class="w-2/6 pb-2">Friday : 14:00:00 - 16:15:00</td>
      </tr>
    </tbody>
  </table>
</div>
  
    `,
  },
  {
    title: "Apa Yang Dimaksud Dengan LQ45?",
    content: `
    <div class="mb-4">
     Indeks LQ 45 adalah nilai kapitalisasi pasar dari 45 saham yang paling likuid dan memiliki nilai kapitalisasi yang besar hal itu merupakan indikator likuidasi. Indeks LQ 45, menggunakan 45 saham yang terpilih berdasarkan Likuiditas perdagangan saham dan disesuaikan setiap enam bulan (setiap awal bulan Februari dan Agustus). Dengan demikian saham yang terdapat dalam indeks tersebut akan selalu berubah.
    </div>
    <a
      class="break-all cursor-pointer text-rose-500"
      target="_blank"
      href="https://www.sinarmassekuritas.co.id/daftar-saham-lq-45"
    >
      Klik disini untuk melihat saham LQ 45
    </a>
    `,
  },
  {
    title: "Apa Yang Dimaksud Dengan LQ SMS Dan Digunakan Untuk Apa?",
    content: `
    <div class="mb-4">
    Indeks LQ 45 adalah nilai kapitalisasi pasar dari 45 saham yang paling likuid dan memiliki nilai kapitalisasi yang besar hal itu merupakan indikator likuidasi. Indeks LQ 45, menggunakan 45 saham yang terpilih berdasarkan Likuiditas perdagangan saham dan disesuaikan setiap enam bulan (setiap awal bulan Februari dan Agustus). Dengan demikian saham yang terdapat dalam indeks tersebut akan selalu berubah.
   </div>
   <a
     class="break-all cursor-pointer text-rose-500"
     target="_blank"
     href="https://www.sinarmassekuritas.co.id/daftar-saham-margin-lq-sms"
   >
     Klik disini untuk melihat saham LQ SMS
   </a>
    `,
  },
  {
    title: "Bagaimana Cara Mengajukan Margin?",
    content: `
    Nasabah minimal sudah menjadi Nasabah PT Sinarmas Sekuritas selama 3 bulan dengan "track record" transaksi yang bagus,minimal pinjaman dan jaminan sebesar Rp. 200.000.000,-.
    `,
  },
  {
    title: "Saham Apa Saja Yang Bisa Ditransaksikan Di Rekening Margin?",
    content: `
    <div class="mb-4">Saham yang termasuk dalam kategori margin yang daftarnya di update setiap awal bulan oleh BEI.</div>

    Klik disini untuk melihat saham Margin
    `,
  },
  {
    title: "Apa Saja Syarat Margin?",
    content: `
    <ul class="list-disc px-4">
      <li class="mb-2">
       Membuka rekening reguler di PT Sinarmas Sekuritas.
      </li>
      <li class="mb-2">
       Mengisi permohonan fasilitas margin.
      </li>
      <li class="mb-2">
       Melampirkan fotocopi KTP Nasabah serta pasangan ( Suami / Istri ) + fotocopi NPWP.
      </li>
      <li>
       Nilai minimal untuk jaminan margin adalah sebesar Rp. 200,000,000,- dan nilai maksimum credit limit yang diberikan kepada setiap Nasabah margin tidak melebihi 15% dari nilai MKBD dengan perbandingan rasio antara jaminan dan credit limit adalah 1:1.
      </li>
    </ul>
    `,
  },
  {
    title: "Berapa % Batas Terkena Margin Call?",
    content: `65% dan akan di "forcesell" jika mencapai ratio 75%`,
  },
  {
    title: "Bagaimana Cara Menghitung Ratio Margin?",
    content: `Hutang / jaminan x 98.5%`,
  },
  {
    title: "Berapa % Bunga Margin?",
    content: `18% p.a`,
  },
];
